<div class="action">
    <span class="action-description">{{ actionDescription }}</span>
    <mat-icon color="primary">{{ actionIcon }}</mat-icon>
</div>

<button
    [id]="'button_fixed-button_Menu'"
    mat-fab
    color="primary"
    [attr.aria-label]="actionDescription"
    class="fixed-button"
    [routerLink]="route"
    *ngIf="!menu && route"
>
    <mat-icon color="secondary">{{ icon }}</mat-icon>
</button>
<button
    [id]="'button_fixed-button_Menu'"
    mat-fab
    color="primary"
    [attr.aria-label]="actionDescription"
    class="fixed-button"
    (click)="emitClick($event)"
    *ngIf="!menu && !route"
>
    <mat-icon color="secondary">{{ icon }}</mat-icon>
</button>
<mat-fab-menu
    [id]="'button_fixed-button_Menu'"
    color="primary"
    [attr.aria-label]="actionDescription"
    class="fixed-button"
    (onFabMenuItemSelected)="subMenuClicked($event)"
    *ngIf="menu"
    [fabButtons]="menu"
>
</mat-fab-menu>
